/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const PROFILE_DATA = {
    title: "Admin",
    img: "https://i.ibb.co/M91w7Nd/VPolice.png",
    meta: [
        {
            key: "Name",
            value: "Nitiksha",
        },
        {
            key: "Email",
            value: "nitikshakatoch@gmail.com",
        },
        {
            key: "Gender",
            value: "Female",
        },
        {
            key: "Role",
            value: "Intern",
        },
        {
            key: "Lorem",
            value: "Lorem"
        },
        {
            key: "Lorem",
            value: "Lorem"
        }
    ]
}